import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppIcon, AppText, styled } from '@streem/ui-react';
import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { calculateRequeueButtonPos } from './requeue-utils';
const BUTTON_HEIGHT_PIXELS = 56;
export const RequeueButton = forwardRef(function RequeueButton(props, ref) {
    // create in a portal so that it is outside of the normal flow
    return createPortal(_jsx(RequeueButtonComponent, { ...props, ref: ref }), document.body);
});
// exported for testing
export const RequeueButtonComponent = forwardRef(function CallTransferRequeueButton({ name, onRequeueTrade, showYn, tradeMenuButtonRef }, ref) {
    async function requeue() {
        await onRequeueTrade(name);
    }
    const buttonRect = tradeMenuButtonRef.current?.getBoundingClientRect();
    if (!showYn || !buttonRect) {
        return null;
    }
    const { top, left } = calculateRequeueButtonPos(buttonRect, BUTTON_HEIGHT_PIXELS);
    return (_jsxs(Button, { onClick: requeue, top: top, left: left, "data-testid": `call-transfer-requeue-button-${name}`, ref: ref, children: [_jsx(AppIcon, { name: "ArrowLeftRightIcon", color: "grey90", size: "small" }), _jsxs(AppText, { size: "medium", color: "grey90", style: { whiteSpace: 'nowrap' }, children: ["Requeue member for ", name] })] }));
});
const Button = styled.button(({ theme, left, top }) => ({
    // position fixed will work since there is no scrolling in the call
    position: 'fixed',
    left,
    top,
    borderRadius: '0.5rem',
    borderColor: 'transparent',
    backgroundColor: theme.colors.blue05,
    height: `${BUTTON_HEIGHT_PIXELS}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    minWidth: '22.5rem',
    boxShadow: theme.shadow.small,
    padding: '1rem 0.5rem',
    columnGap: '0.5rem',
    ':hover': {
        cursor: 'pointer',
    },
    zIndex: 100,
}));
//# sourceMappingURL=requeue_button.js.map